import { Role } from '@guiker/permissions'

import { TenantApplicationRoleNames } from '../role-names'
import { TenantApplicationActions } from '../tenant-application-actions'

export const InvitedGuarantorRole: Role = {
  name: TenantApplicationRoleNames.INVITED_GUARANTOR,
  permissions: [{ action: TenantApplicationActions.EditGuarantorInfo }],
}
